import React from 'react';
import { captureReactError } from '../lib/sentry';
import { AlertTriangle } from 'lucide-react';

/**
 * ErrorBoundary global — capture les erreurs de rendu React
 * et affiche un écran de secours plutôt qu'une page blanche.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Envoyer à Sentry (silencieux si DSN absent)
    captureReactError(error, info);

    // Log en développement uniquement
    if (process.env.NODE_ENV === 'development') {
      console.error('[ErrorBoundary] Erreur capturée:', error);
      console.error('[ErrorBoundary] Stack:', info.componentStack);
    }
  }

  handleReset() {
    this.setState({ hasError: false, error: null });
    window.location.href = '/';
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '2rem',
          fontFamily: 'system-ui, sans-serif',
          background: '#f9fafb'
        }}>
          <div style={{
            maxWidth: '480px',
            textAlign: 'center',
            background: '#fff',
            borderRadius: '12px',
            padding: '2.5rem',
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
          }}>
            <AlertTriangle size={48} color="#B45309" aria-hidden="true" style={{ margin: '0 auto 1rem' }} />
            <h1 style={{ fontSize: '1.5rem', fontWeight: 700, color: '#111827', marginBottom: '0.5rem' }}>
              Une erreur est survenue
            </h1>
            <p style={{ color: '#6b7280', marginBottom: '1.5rem', lineHeight: 1.6 }}>
              Le module MOOC a rencontré un problème inattendu.
              Cliquez sur le bouton ci-dessous pour retourner à l'accueil.
            </p>
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <pre style={{
                textAlign: 'left',
                background: '#fef2f2',
                border: '1px solid #fecaca',
                borderRadius: '6px',
                padding: '1rem',
                fontSize: '0.75rem',
                color: '#991b1b',
                overflowX: 'auto',
                marginBottom: '1.5rem',
                maxHeight: '200px',
                overflowY: 'auto'
              }}>
                {this.state.error.toString()}
              </pre>
            )}
            <button
              onClick={() => this.handleReset()}
              style={{
                background: '#2563eb',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                padding: '0.75rem 2rem',
                fontSize: '1rem',
                fontWeight: 600,
                cursor: 'pointer'
              }}
            >
              Retour à l'accueil
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
